import { createDeleteEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type DeleteOidcConfigurationByCustomerRequest = {
	customerId?: number;
	shardName?: string;
};

export const deleteOidcConfigurationByCustomer = createDeleteEndpoint<DeleteOidcConfigurationByCustomerRequest, void>(
	(request) => `/api/v3/security/oidc/by-customer/${request?.customerId ?? 'current'}`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		skipAuthRefresh: true
	}
);
